/**
 * Local-calendar date helpers for <input type="date"> defaults. The old idiom
 * `new Date(Date.now() + n).toISOString().slice(0, 10)` yields the UTC
 * calendar day — off by one from what the operator's wall clock says around
 * midnight (or for any TZ ahead of UTC in the evening). These format the
 * operator's LOCAL Y-M-D.
 */
export function ymdLocal(d: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${String(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function ymdLocalPlusDays(days: number, from: Date = new Date()): string {
  const d = new Date(from);
  d.setDate(d.getDate() + days);
  return ymdLocal(d);
}
